import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IState, Loader } from './types';

// --------------------------------------------

export const initialState: IState = {
  token: '',
  selectedProjectId: 0,
  loaders: [],
};

const slice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    setSelectedProjectId(state, action: PayloadAction<number | undefined>) {
      state.selectedProjectId = action.payload;
    },

    presentLoader(state, action: PayloadAction<Loader>) {
      const { id, options } = action.payload;
      state.loaders.push({ id, options });
    },
    dismissLoader(state, action: PayloadAction<{ id: string }>) {
      if (!state.loaders) {
        state.loaders = [];
      }
      state.loaders = state.loaders.filter((loader) => loader.id !== action.payload.id);
    },
  },
});

export default slice.reducer;

export const commonSlice = slice.reducer;

export const { setToken, setSelectedProjectId, presentLoader, dismissLoader } = slice.actions;

export const loader = {
  present: (action: string, options?: Loader['options']) => presentLoader({ id: action, options }),
  dismiss: (action: string) => dismissLoader({ id: action }),
};
